import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { userLoginAsync, ipAsync } from "../_redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./body.scss";


const initialValues = {
  emailId: "",
  password: "",
  showField: "email",
  contactNumber: ""
};

const addBodyClass = (className) =>
  document.body.classList.add("removeHeaderFooter");
const removeBodyClass = (className) =>
  document.body.classList.remove("removeHeaderFooter");

function Login(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass("removeHeaderFooter");

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass("removeHeaderFooter");
    };
  }, [props.className]);
  const { intl } = props;
  const dispatch = useDispatch();

  const [passwordShown, setPasswordShown] = useState(false);

  const [countryCode, setCountryCode] = useState({ country: "", code: "" });

  useEffect(() => {
		// ipAsync().then(data => {
		// 	setCountryCode({ country: data.gec.toLowerCase(), code: "+" + data.country_code })
    // });
    setCountryCode({ country: 'us', code: "+" + 1 })
	}, [])

  const { redirectLoginVerification, isLoading, flashMessage } = useSelector(
    (state) => state.auth,
    shallowEqual
  );
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

  const phoneRef = useRef();
	const emailRef = useRef();

  const LoginSchema = Yup.object().shape({
    emailId: Yup.string().trim()
      .when("showField", {
        is: "email",
        then: Yup.string()
          .email("Please enter valid email address")
          .required("Please enter email"),
      }),
      // .when("showField", {
      //   is: "phone",
      //   then: Yup.string().matches(phoneRegExp, "Contact Number is not valid"),
      // }),
    password: Yup.string()
      .required("Please enter a password")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
        "Password must Contain at least 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character from the followings: [ @$!%*#?& ]"
      ),
  });

  const emailNumberInputChange = (e) => {
    let value = e.target.value;
    formik.handleChange(e);
    if (/^[\+]?[(]?[0-9]{3,13}[)]?$/.test(value)) {
      formik.setFieldValue("showField", "phone");
      return;
    }
    formik.setFieldValue("showField", "email");
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      let user = {
        password: values.password,
      };
      if (values.showField === "email") {
        user.emailId = values.emailId;
      }
      if (values.showField === "phone") {
        user.contactNumber = values.contactNumber;
      }
      dispatch(userLoginAsync(user, formik.values.showField));
    },
  });

  useEffect(() => {
		let showField = formik.values.showField;
		if (showField === "email" && emailRef.current) {
			emailRef.current.focus();
		}
		if (showField === "phone" && phoneRef.current) {
			phoneRef.current.numberInputRef.focus()
		}
	}, [formik.values.showField])

  // redirect to verify OTP page
  if (redirectLoginVerification) {
    return <Redirect to="/verification" />;
  }

  return (
    <>
      <div className="inner_main">
        <div className="row w-100">
          <div className="col-xl-3 d-flex align-items-end justify-content-center d_none_1199">
            <div>
              <img
                alt=""
                className="img-fluid"
                src={toAbsoluteUrl("/media/others/developer-outline.png")}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="row">
              <div className="col-md-12 text-center mt-15 mb-10">
                <img
                  alt="Logo"
                  className="max-h-70px mb-5"
                  src={toAbsoluteUrl("/media/logos/auth_logo.png")}
                />
              </div>
              {flashMessage ? (
                <div
                  className="mb-10 alert alert-custom alert-light-danger alert-dismissible"
                  style={{ margin: "auto" }}
                >
                  <div className="alert-text font-weight-bold">
                    {flashMessage}
                  </div>
                </div>
              ) : null}
              <div className="col-md-12">
                <div className="wt_box">
                  <div
                    className="login-form login-signin"
                    id="kt_login_signin_form"
                  >
                    {/* begin::Head */}
                    <div className="text-center mb-10 mb-lg-15">
                      <h3 className="fn_s_32 color_blk f-w-500 mt-3">
                        Hello Guest
                      </h3>
                      <p className="opacity60 fn_s_16 color_blk f-w-400">
                        Welcome! Please login with your details.
                      </p>
                    </div>
                    {/* end::Head */}

                    {/*begin::Form*/}
                    <form
                      onSubmit={formik.handleSubmit}
                      className="form def_form"
                    >
                      <div className="form-group">
                        {/* <label className="form-label">Email/Phone</label> */}

                        {/* Email Input */}
                        <div className="d-flex justify-content-between">
													<label className="form-label">{formik.values.showField === "email" ? "Email" : "Phone"}</label>
													<label className="form-label dynamic_email_phone_label"
														onClick={() => formik.setFieldValue('showField', formik.values.showField === "email" ? "phone" : "email")}
													>
														Login with {formik.values.showField === "email" ? "Phone" : "Email"}
													</label>
												</div>

												{/* Email Input */}
												{
													formik.values.showField === "email" && (
														<input
															placeholder="Email"
															type="text"
															className={`form-control ${getInputClasses(
																"emailId"
															)} password-valid`}
															name="emailId"
															onChange={formik.handleChange}
															onBlur={formik.handleBlur}
															value={formik.values.emailId}
															ref={emailRef}
														/>
													)
												}
												{
													formik.values.showField === "phone" && (
														<PhoneInput
															inputProps={{
																name: 'contactNumber',
															}}
															countryCodeEditable={false}
															placeholder="Phone"
															country={countryCode.country}
															value={formik.values.contactNumber}
															inputClass="dynamic_phoneInput"
															buttonClass="dynamic_countryDrop"
															onChange={(phone, data, event) => {
                                // formik.handleChange(event)
                                formik.setFieldValue('contactNumber', phone)
															}}
															ref={phoneRef}
														/>
													)
												}
												{formik.values.showField === "email" &&
													formik.touched.emailId &&
													formik.errors.emailId ? (
														<div className="fv-plugins-message-container">
															<div className="fv-help-block">
																{formik.errors.emailId}
															</div>
														</div>
													) : null}

												{formik.values.showField === "phone" &&
													formik.touched.contactNumber &&
													formik.errors.contactNumber ? (
														<div className="fv-plugins-message-container">
															<div className="fv-help-block">
																{formik.errors.contactNumber}
															</div>
														</div>
													) : null}
                      </div>

                      <div className="form-group mb-3">
                        <label className="form-label">Password</label>
                        <div className="frpsswrd">
                          <input
                            placeholder="Password"
                            type={passwordShown ? "text" : "password"}
                            className={`form-control ${getInputClasses(
                              "password"
                            )}`}
                            name="password"
                            {...formik.getFieldProps("password")}
                          />
                          <i
                            onClick={togglePasswordVisiblity}
                            className="far fa-eye-slash"
                          ></i>
                        </div>
                        {formik.touched.password && formik.errors.password ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.password}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="form-group d-flex flex-wrap justify-content-between align-items-center mt-10 mb-0">
                        <label className="fn_s_14 color_light f-w-400 align-items-center d-flex mt-2">
                          <div className="ap_checkbox">
                            <input
                              type="checkbox"
                              className={`mr-2 checkbox ${getInputClasses(
                                "checkbox"
                              )}`}
                              name="checkbox"
                              {...formik.getFieldProps("checkbox")}
                            />
                            <label></label>
                          </div>
                          Remember Me
                        </label>
                        <button
                          disabled={isLoading}
                          id="kt_login_signin_submit"
                          type="submit"
                          className={`btn btn-def ${
                            !isLoading ? "defwtarw" : ""
                          }`}
                        >
                          <span>Continue</span>
                          {isLoading && (
                            <span className="ml-3 spinner spinner-white"></span>
                          )}
                        </button>
                        {/* <Link to="/verification" className="btn btn-def defwtarw">Continue</Link> */}
                      </div>
                    </form>
                    {/*end::Form*/}
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center mt-10 bottom_links">
                <Link
                  to="/forgot-password"
                  className="fn_s_16 color_blue f-w-400 my-3"
                  id="kt_login_forgot"
                >
                  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                </Link>
                <p className="fn_s_16 color_blk f-w-400 mt-2 mb-10">
                  <span className="opacity50">
                    Don’t have an account? &nbsp;
                  </span>
                  <Link to="/register" className="fn_s_16 color_blue f-w-400">
                    Register Now
                  </Link>
                </p>
                <Link
                  to="/"
                  className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                >
                  Back To Home
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 d_none_1199">
            <img
              alt=""
              className="img-fluid mt-20"
              src={toAbsoluteUrl("/media/others/support-solid.png")}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(Login);
